import { StoreApi } from 'zustand';

/* Simple abstraction to assist in setting simple values */
export const simpleStoreSetter =
  (store: StoreApi<object>, key: string, seededValue?: any) =>
  (value: any = seededValue) => {
    store.setState((state: any) => {
      state[key] = value;
    });
  };
